import { ImpressaoIntencaoVendaRequest } from 'store/modules/api/detranCrv/IntencaoDeVenda/Imprimir/types';
import * as Yup from 'yup';

interface ILocalidade {
	id: number;
	desc: string;
}

export const initialValues: ImpressaoIntencaoVendaRequest = {
	placa: '',
	renavam: '',
	instanceRequest: null,
};

export function treatValues(
	values: ImpressaoIntencaoVendaRequest,
): ImpressaoIntencaoVendaRequest {
	const formattedData = {
		placa: values.placa?.trim().toUpperCase() || '',
		renavam: values.renavam?.trim() || '',
		instanceRequest: null,
	};

	return formattedData;
}

export const schema = Yup.object<ImpressaoIntencaoVendaRequest>().shape({
	placa: Yup.string().required(`Campo Obrigatório: Placa.`),
	renavam: Yup.string().required(`Campo Obrigatório: Renavam.`),
});
